import React, { useContext } from 'react';
import { WMConditionalEllipsis } from '@walkme/wm-ui';
import clsx from 'clsx';
import { AppTableContext } from '../../AppTableContext';

import classes from './DataCell.module.scss';
import { getFormatNumberString } from '../../../../helpers/getFormatNumberString';

interface IDataCell {
    className?: string;
    data?: string | number;
    id: string;
    testKey: string;
    capitalize?: boolean;
    disableConditionalEllipsis?: boolean;
    isDate?: boolean;
    onClick?: () => void;
    smallFont?: boolean;
}

const DataCell = ({ className, data, id, testKey, onClick, capitalize, disableConditionalEllipsis, isDate, smallFont }: IDataCell) => {
    const { tableDataTestid } = useContext(AppTableContext);

    const dataTestId = [id, testKey, tableDataTestid].filter(Boolean).join('-');

    let text = data?.toString() ?? '';

    const [day, year, time] = text.split(',');

    text = text !== '' && !isNaN(Number(text)) ? getFormatNumberString(Number(text)) : text;

    return (
        <div
            onClick={onClick}
            className={clsx(classes.dataCell, className, {
                [classes.clickable]: onClick,
                [classes.capitalize]: capitalize,
                [classes.small]: smallFont
            })}
            data-testid={dataTestId}
        >
            {isDate && day && year && time && text.length > 0 ? (
                <div className={classes.dateWrapper}>
                    <span className={classes.date}>{`${day},${year},`}</span>
                    <span className={classes.date}>{`${time}`}</span>
                </div>
            ) : disableConditionalEllipsis ? (
                <span>{text || '-'}</span>
            ) : (
                <WMConditionalEllipsis value={text || '-'} className={clsx(classes.dataCell, { [classes.small]: smallFont })} />
            )}
        </div>
    );
};

export default DataCell;
